const e = "Y", o = "Volver", a = "Cerrar", r = "Continuar", s = "días", n = "d", i = "Correo electrónico", t = "Hola", c = "hora", l = "horas", d = "h", u = "minutos", X = "min", m = "ninguno", p = "Opcional", h = "personas", y = "persona", b = "Registrarme", g = "segundos", f = "s", v = "Enviando", C = "Al hacer clic en este enlace, acepta recibir nuestros planes y promociones con fines comerciales. De conformidad con el Reglamento General de Protección de Datos (GDPR), informamos que sus datos se incorporarán a nuestras bases de datos. Como cliente, puede conocer y acceder libremente a los datos personales bajo nuestro control y ejercer sus derechos como propietario de estos datos de acuerdo con GDPR.", T = "Acepto los términos y condiciones", E = {
  "(Optional)": "(Opcional)",
  "Already registered?": "¿Estás registrado?",
  and: e,
  "Apply promocode": "Aplicar código promocional",
  Back: o,
  "Book Now": "Reserva ahora",
  "Call Now": "Llame ahora",
  "Click here": "Clica aquí",
  Close: a,
  "Close dialog": "Cerrar diálogo",
  "Confirm your email": "Confirme su correo electrónico",
  "Contact Now": "Contacto",
  Continue: r,
  days: s,
  days_abbr: n,
  Email: i,
  "Enter the validation code sent to your email": "Introduzca el código de validación enviado a su correo electrónico",
  "Exclusive benefits unlocked!": "¡Ventajas exclusivas desbloqueadas!",
  "Expand notification": "Ampliar notificación",
  "Great! Email successfully sent!": "¡Perfecto! Email enviado correctamente",
  Hello: t,
  hour: c,
  hours: l,
  hours_abbr: d,
  "I agree to the": "Estoy de acuerdo con el",
  "Invalid code": "Código no válido",
  "Last reservation was XXXXXX hours ago": "La última reserva fue hace XXXXXX horas",
  "Loyalty Login": "Loyalty Login",
  "Loyalty Login's default Terms & Conditions": "Términos y condiciones predeterminados de Loyalty Login",
  "Main content": "Contenido principal",
  minutes: u,
  minutes_abbr: X,
  none: m,
  "Not registered yet?": "¿Aún no te has registrado?",
  "Not registered?": "¿No estás registrado?",
  "Only for registered users": "Sólo para usuarios registrados",
  "Only for specific rates": "Sólo para tarifas específicas",
  Optional: p,
  people: h,
  "Perk 1 will be listed here": "La ventaja 1 aparecerá aquí",
  "Perk 2 will be listed here": "La ventaja 2 aparecerá aquí",
  "Perk 3 will be listed here": "La ventaja 3 aparecerá aquí",
  person: y,
  "Picture icon": "Icono de imagen",
  "Please, provide a valid e-mail": "Por favor, proporcione un correo electrónico válido",
  "Privacy policy": "Política de privacidad",
  Register: b,
  "Resend code": "Reenviar código",
  seconds: g,
  seconds_abbr: f,
  "Send to booking engine": "Enviar al motor de reservas",
  Sending: v,
  "Sending search": "Enviando la búsqueda",
  "Sign in": "Iniciar sesión",
  "Sign in to your account": "Accede a tu cuenta",
  "Something went wrong. Please, try again later.": "Algo ha ido mal. Por favor, inténtelo más tarde.",
  "Subject to availability": "Sujeto a disponibilidad",
  "Terms and conditions": "Términos y condiciones",
  Terms_default: C,
  Terms_default_label: T,
  "Thank you!": "¡Gracias!",
  "There are XXXXXX people looking at this hotel right now": "Hay XXXXXX personas mirando este hotel",
  "There has been an error.": "Ha habido un error.",
  "This conversation will be recorded for quality and training purposes.": "Esta conversación se grabará con fines de calidad y formación.",
  "This is a standard paragraph, use it to display information.": "Este es un párrafo estándar, utilízalo para mostrar información.",
  'This is paragraph. <b>Bold</b> it, <i>italicise</i> it, <u>underline</u> it, add <a href="#">links</a>, emojis 🙂, and more!': 'Esto es párrafo. <b>Negrita</b>, <i>italiza</i>, <u>subraya</u>, añade <a href="#">enlaces</a>, emojis 🙂 ¡y mucho más!',
  "Title of your message": "Título del mensaje",
  "Today's special offer: XXXXXX": "Hoy oferta especial: XXXXXX",
  "View all XXXXXX perks": "Ver todas las ventajas de XXXXXX",
  "We have received your form submission correctly": "Hemos recibido correctamente el envío de su formulario.",
  "We will send you an email with your search very soon.": "Le enviaremos un correo electrónico con su búsqueda muy pronto",
  "Web exclusive": "Exclusivo en web",
  "XXXXXX people have already booked today": "XXXXXX personas ya han reservado este hotel hoy",
  "XXXXXX people have looked at this hotel today": "XXXXXX personas han mirado este hotel hoy",
  "XXXXXX% discount only today": "Hoy, XXXXXX% descuento",
  "You must agree to the Terms & Conditions first": "Primero debes aceptar los Términos y Condiciones",
  "Your email": "Tu correo electrónico",
  "Your email address has been successfully added to our list.": "Tu email ha sido añadido correctamente."
};
export {
  o as Back,
  a as Close,
  r as Continue,
  i as Email,
  t as Hello,
  p as Optional,
  b as Register,
  v as Sending,
  C as Terms_default,
  T as Terms_default_label,
  e as and,
  s as days,
  n as days_abbr,
  E as default,
  c as hour,
  l as hours,
  d as hours_abbr,
  u as minutes,
  X as minutes_abbr,
  m as none,
  h as people,
  y as person,
  g as seconds,
  f as seconds_abbr
};
//# sourceMappingURL=es.DANaCrW0.js.map
